import { BoxSymbol } from "@spz/ui/components/box-symbol";
import { Typography } from "@spz/ui/components/typography";
import { useMemo } from "react";
import type { FieldValue } from "../../../shared/types/workflow/workflow-form.types";
import { useWorkflowFormContext } from "./workflow-form-context";
import { WorkflowFormField } from "./workflow-form-field";

export function WorkflowDialogContent({ className }: { className?: string }) {
  const form = useWorkflowFormContext();
  const fields = useMemo(
    () => form?.schema?.action?.fields ?? [],
    [form?.schema],
  );

  return (
    <div className={className}>
      {form &&
        fields.map((field, index) => {
          return (
            <div key={field.name} className="flex flex-col  gap-4">
              {field.required && (
                <div className="flex items-center gap-2">
                  <BoxSymbol
                    size="sm"
                    symbol={index + 1}
                    bgColorClassName="bg-pink-50"
                    textColorClassName="text-pink-500"
                  />

                  <div className="flex gap-1">
                    <Typography trans={field.name} className="font-semibold" />
                    {field.required && <span className="text-pink-500">*</span>}
                  </div>
                </div>
              )}
              <WorkflowFormField
                companyId={form.companyId}
                key={field.name}
                field={field}
                value={form.formState[field.name] as FieldValue}
                error={
                  form.touched.has(field.name)
                    ? form.errors[field.name]
                    : undefined
                }
                onChange={(val) => {
                  form.updateField(field.name, val);
                  form.validateField(field.name, undefined, val);
                }}
                onBlur={() => form.touchField(field.name)}
              />
            </div>
          );
        })}
    </div>
  );
}
